import { render, staticRenderFns } from "./AIChart.vue?vue&type=template&id=000038a3&scoped=true&"
import script from "./AIChart.vue?vue&type=script&lang=js&"
export * from "./AIChart.vue?vue&type=script&lang=js&"
import style0 from "./AIChart.vue?vue&type=style&index=0&id=000038a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000038a3",
  null
  
)

export default component.exports